












import { faMap, faList } from '@fortawesome/free-solid-svg-icons'
import { mapMutations, mapState } from 'vuex'
import { DEALERS_MAP_NS } from '~/store/modules/shared/dealers/map/state'
import { TOGGLE_MOBILE_LIST_VISIBLE } from '~/store/modules/shared/dealers/map/mutation-types'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  data: () => ({
    icons: {
      map: faMap,
      list: faList
    }
  }),
  computed: {
    ...mapState(DEALERS_MAP_NS, {
      mobileListVisible: state => state.mobile.listVisible
    })
  },
  methods: {
    ...mapMutations(DEALERS_MAP_NS, {
      toggleMobileListVisible: TOGGLE_MOBILE_LIST_VISIBLE
    })
  }
})
